import { useEffect, useState } from "react";
import { ArrowRightGreyIcon, CalendarGreyIcon, ClocckGreyIcon, LocationGreyIcon, TableFrontGreyIcon, TableGreyIcon, UserGreyIcon } from "../../../assets/icons";
import { OrderStatusType, orderStatusTypeStringToEnum, orderStatusTypeToString } from "../../../models/base/OrderStatusType";
import { useStepContext } from "@mui/material";
import { OrderType, orderTypeToString } from "../../../models/base/OrderType";
import { number } from "framer-motion";
import { useParams } from "react-router-dom";
import { useNotification } from "../../toster-notification/NotificationContext";
import { orderService } from "../../../services/orderService";
import { OrderHistoryDTO } from "../../../models/order/order.response";
import { handleErrorNotification } from "../../../utils/errorNotificatioMessage";
import { ToLocalDateTimeString } from "../../../utils/dateFormater";
import Loader from "../../shared/Loader";
import UserModalTrigger from "../../shared/user-modal/UserModalTrigger";
import OrderHistoryCardDineIn from "./OrderHistoryCardDineIn";
import OrderHistoryCardPickUp from "./OrderHistoryCardPickUp";
import OrderHistoryCardDelivery from "./OrderHistoryCardDelivery";
import OrderInfoModalView from "../../live-orders/shared/views/modal-view/OrderInfoModalView";



const OrderHistoryPage: React.FC = () => {

    const [orders, setOrders] = useState<OrderHistoryDTO[]>([]);

    const [filterSearch, setFilterSearch] = useState<string>("");
    const [orderStatusType, setOrderStatusType] = useState<OrderStatusType | null>(null);
    const [orderType, setOrderType] = useState<OrderType | null>(null);
    const [ordersDay, setOrdersDay] = useState<string>(new Date().toISOString().split('T')[0]);

    const [selectedOrderId, setSelectedOrderId] = useState<string>("");

    const [loading, setLoading] = useState<boolean>(false);
    const localId = useParams().localId;
    const { notify } = useNotification();


    useEffect(() => {
        fetchOrders();
    }, [localId, ordersDay]);


    const fetchOrders = async () => {
        if (localId == null) {
            notify("error", "Id lokala nije prosleđen")
            return;
        }

        if (ordersDay == null) {
            notify("error", "Nije izabran datum")
            return;
        }

        setLoading(true);
        try {
            const response = await orderService.getOrdersHistory(localId, new Date(ordersDay));

            if (response.data && response.success) {
                setOrders(response.data);
            } else {
                notify("error", "Greška prilikom dobavljanja istorije porudžbina");
            }
        } catch (error: any) {
            notify("error", "Greška prilikom dobavljanja istorije porudžbina");
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        <Loader />
    }

    return (
        <>
            {selectedOrderId &&
                <OrderInfoModalView
                    selectedOrderId={selectedOrderId}
                    onClose={() => setSelectedOrderId("")}
                />
            }

            <section className="order-history-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="sttings-content-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Istorija porudžbina</h2>
                                <div className="text-block">
                                    Pregled i upravljanje rezervacijama stolova<br />
                                </div>
                            </div>
                        </div>
                        <div className="div-block-94">
                            <div className="admin-settings-box-div reservation-info">
                                <div>
                                    <div className="description-text fs-1rem">Ukupno porudžbina</div>
                                    <div className="fs-1-5rem">{orders.length}</div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div reservation-info">
                                <div>
                                    <div className="description-text fs-1rem">Završeno</div>
                                    <div className="fs-1-5rem">{orders.filter(o => o.currentStatus == OrderStatusType.Finished).length}</div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div reservation-info">
                                <div>
                                    <div className="description-text fs-1rem">Otkazano</div>
                                    <div className="fs-1-5rem">{orders.filter(o => o.currentStatus == OrderStatusType.Cancelled).length}</div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div reservation-info">
                                <div>
                                    <div className="description-text fs-1rem">Ukupan prihod</div>
                                    <div className="fs-1-5rem">{orders.reduce((accumulator, currentValue) => (accumulator + (currentValue.currentStatus === OrderStatusType.Cancelled ? 0 : currentValue.price)), 0)}</div>
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div">
                            <div className="fs-1rem">Filteri</div>
                            <div className="w-form">
                                <form className="form-8">
                                    <div className="filter-div">
                                        <div className="description-text">Pretraga</div>
                                        <input className="form-input w-input" placeholder="Pretraga po id, imenu korisnika, adresi..." type="text"
                                            value={filterSearch}
                                            onChange={(e) => setFilterSearch(e.target.value)}
                                        />
                                    </div>
                                    <div className="filter-div">
                                        <div className="description-text">Tip</div>
                                        <select className="form-select auto-width w-select"
                                            value={orderType ?? ""}
                                            onChange={(e) => setOrderType(e.target.value === "" ? null : Number(e.target.value))}                                    >
                                            <option value="">Svi</option>
                                            <option value={OrderType.Delivery}>Dostava</option>
                                            <option value={OrderType.DineIn}>U lokalu</option>
                                            <option value={OrderType.Pickup}>Lično preuzimanje</option>
                                        </select>
                                    </div>
                                    <div className="filter-div">
                                        <div className="description-text">Status</div>
                                        <select className="form-select auto-width w-select"
                                            value={orderStatusType ?? ""}
                                            onChange={(e) => setOrderStatusType(e.target.value === "" ? null : Number(e.target.value))}
                                        >
                                            <option value="">Otkazano i Završeno</option>
                                            <option value={OrderStatusType.Cancelled}>Otkazano</option>
                                            <option value={OrderStatusType.Finished}>Završeno</option>
                                        </select>
                                    </div>
                                    <div className="filter-div">
                                        <div className="description-text">Datum</div>
                                        <input className="form-input grey" type="date"
                                            value={ordersDay}
                                            onChange={(e) => setOrdersDay(e.target.value)}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="order-history-list-div">

                            {orders
                                .filter(o => {
                                    const search = filterSearch.toLowerCase();
                                    let matchesSearch = !filterSearch
                                        || o.id.toLowerCase().includes(search)
                                        || o.street?.toLowerCase().includes(search)
                                        || o.fullName.toLowerCase().includes(search);

                                    if (orderStatusType !== null) {
                                        matchesSearch = matchesSearch && o.currentStatus === orderStatusType;
                                    }

                                    if (orderType !== null) {
                                        matchesSearch = matchesSearch && o.type === orderType;
                                    }

                                    return matchesSearch;
                                })
                                .map(order => (
                                    <>
                                        {order.type === OrderType.DineIn &&
                                            <OrderHistoryCardDineIn
                                                order={order}
                                                setSelectedOrderId={(orderId) => setSelectedOrderId(orderId)}
                                            />
                                        }

                                        {order.type === OrderType.Pickup &&
                                            <OrderHistoryCardPickUp
                                                order={order}
                                                setSelectedOrderId={(orderId) => setSelectedOrderId(orderId)}
                                            />
                                        }

                                        {order.type === OrderType.Delivery &&
                                            <OrderHistoryCardDelivery
                                                order={order}
                                                setSelectedOrderId={(orderId) => setSelectedOrderId(orderId)}
                                            />
                                        }
                                    </>
                                ))}

                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default OrderHistoryPage;